import { useSelector } from "react-redux";
import { downloadFile } from "../../Actions/FileManagerAction";
import Download from "../../components/Common/icons/Download";
import { useState } from "react";

const TicketFileItem = props => {

    const {item} = props;
    const Dictionary = useSelector(state => state.VisualData.Dictionary);

    const LAN = useSelector(state => state.VisualData.LAN);
    const token = localStorage.getItem("userToken");

    const [loading, setLoading] = useState(false);

    const handleDownloadClick = async (fileUniqKey) => {
        setLoading(true);
        const response = await downloadFile({
            "id": fileUniqKey
        }, LAN , token);
        
        setLoading(false);
        if(response?.data?.success && response?.data?.result){
            const {result} = response.data;
            window.open(`${process.env.REACT_APP_SERVER_TYPE}${process.env.REACT_APP_SERVER_FILE_MANAGER}/File/DownloadTempFile?fileName=${result.fileName}&fileToken=${result.fileToken}&fileType=${result.fileType}`); 
        }

    }

    return(
        <button
        type="button"
        className="ticketing-file-item"
        onClick={() => handleDownloadClick(item.fileUniqKey)}
    >
        <Download className="button-icon" />  {Dictionary.DownloadAttachment} {loading && <span className="margin-start-half loading-inline-circle" />}
    </button>
    )
}

export default TicketFileItem;